<gc-branding [branding]="branding"></gc-branding>
<div [attr.aria-hidden]="hasModalOpen">
  <ng-container *ngIf="loggedIn">
    <div>
      <yc-banner
        [banners]="banners">
      </yc-banner>
      <!-- Timeout Warning -->
      <div class="timeout-modal" 
        [ngClass]="{'active' : showTimeout$ | async}">
        <div class="fs-modal">
          <div class="fs-modal-content">
            <div class="fs-modal-panel">
              <div class="fs-icon far  fa-warning"></div>
              <div class="fs-header">
                <yc-i18n
                  key="NAV:textTimeoutHeader"
                  defaultValue="You are about to be signed out.">
                </yc-i18n>
              </div>
              <div class="fs-message">
                <span>
                  <yc-i18n
                    key="NAV:textTimeoutDesc"
                    [context]="{
                      seconds: timeRemaining$ | async
                    }"
                    defaultValue="It doesn't look like you are active. For your security, we will sign you out of GrantsConnect in __seconds__ seconds.">
                  </yc-i18n>
                </span>
              </div>
              <div class="d-flex align-items-center justify-content-between mobile">            
                <div class="mobile order-sm-2">
                  <yc-button
                    [primary]="true"
                    [langKey]="'NAV:textKeepMeSignedIn'"
                    [defaultText]="'Keep me signed in'"
                    (onClick)="keepMeSignedIn()">
                  </yc-button>
                </div>
                <div class="mobile order-sm-1">
                  <yc-button
                    [link]="true"
                    [langKey]="'common:btnSignOut'"
                    [defaultText]="'Sign out'"
                    (onClick)="onSignOutClick()">
                  </yc-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Non Mobile -->
      <div class="d-none d-lg-flex navbar gcm-fixed-nav-light navbar-fixed-top">
        <ng-template *ngTemplateOutlet="headerImage"></ng-template>
        <ng-template *ngTemplateOutlet="menu; context: {
          isMobile: false
        }"></ng-template>
        <ng-template *ngTemplateOutlet="helpCircle"></ng-template>
        <ng-template *ngTemplateOutlet="accountDropdown"></ng-template>
      </div>

      <!-- Mobile -->
      <div class="d-lg-none navbar gcm-fixed-nav-light navbar-fixed-top">
        <ng-template *ngTemplateOutlet="menuBars"></ng-template>
        <ng-template *ngTemplateOutlet="headerImage; context: {
          isMobile: true
        }"></ng-template>
        <ng-template *ngTemplateOutlet="helpCircle"></ng-template>
        <ng-template *ngTemplateOutlet="accountDropdown"></ng-template>
      </div>

      <div *ngIf="mobileMenuOpen"
        class="mobile-menu">
        <div class="d-flex align-items-center p-3 mt-1">
          <ng-template *ngTemplateOutlet="menuBars"></ng-template>
          <ng-template *ngTemplateOutlet="headerImage; context: {
            isMobile: true
          }"></ng-template>
        </div>
        <ng-template *ngTemplateOutlet="menu; context: {
          isMobile: true
        }"></ng-template>
      </div>
    </div>
  </ng-container>


  <div [class.container-fluid]="loggedIn">
    <router-outlet></router-outlet>
  </div>

  <!-- Footer -->
  <footer *ngIf="loggedIn">
    <!-- Non Mobile -->
    <div class="d-none d-md-flex footer-wrapper">
      <!-- Terms -->
      <div class="d-flex justify-content-end flex-basis-50 flex-grow-1">
        <ng-template *ngTemplateOutlet="terms"></ng-template>
      </div>
    </div>

    <!-- Mobile -->
    <div class="d-flex d-md-none footer-wrapper">
      <!-- Terms -->
      <div class="d-flex justify-content-end flex-basis-50 flex-grow-1">
        <ng-template 
          *ngTemplateOutlet="terms; context: {
            mobile: true
          }">
        </ng-template>
      </div>
    </div>
  </footer>
</div>



<!-- Start Templates -->

<ng-template #terms
  let-mobile="mobile">
  <div>
    {{ copyrightText }}
    <span *ngIf="termsOfServiceLink"
      class="pe-1 cursor-p underline-link">
      <a [href]="termsOfServiceLink" target="_blank">
        <yc-i18n 
          key="common:textTermsOfService"
          defaultValue="Terms of Service">
        </yc-i18n>
      </a>
    </span>
    <span class="vertical-divider">|</span>
    <span *ngIf="privacyPolicyLink"
      class="pe-1 cursor-p underline-link">
      <a [href]="privacyPolicyLink" target="_blank">
        <yc-i18n 
          key="common:textPrivacyPolicy"
          defaultValue="Privacy Policy">
        </yc-i18n>
      </a>
    </span>
  </div>
</ng-template>

<ng-template #headerImage
  let-isMobile="isMobile">
  <div class="fixed-nav-brand-img"
    [class.mobile-fixed-nav-brand-img]="isMobile">
    <img [class.blackbaud-img]="isBBGMApplicant"
      [src]="!isBBGMApplicant ?
        './assets/img/yc-nav-icon.svg' :
        './assets/img/blackbaud_transparent_dark_font_logo.png'"
      [alt]="!isBBGMApplicant ? 
        'YourCause - My GrantsConnect' :
        'Blackbaud'">
  </div>
</ng-template>

<ng-template #menuBars>
  <yc-button 
    [icon]="true"
    [fontAwesomeIcon]="'bars'"
    size="xl"
    [value]="'common:textNavigation' | ycI18n: 'Navigation'"
    (onClick)="toggleMobileMenu()">
  </yc-button>
</ng-template>

<ng-template #menu
  let-isMobile="isMobile">
  <nav cdkMenu
    class="navbar-nav">
    <ul class="nav navbar-nav">
      <li cdkMenuItem>
        <yc-button
          [link]="true"
          class="main-nav-item" 
          [langKey]="'common:hdrApplications'"
          [defaultText]="'Applications'"
          [fontAwesomeIcon]="'file'"
          [linkPath]="['/apply/applications']"
          (OnClick)="mobileMenuOpen = false;">
        </yc-button>
      </li>
      <li *ngIf="hasInvitations"
        cdkMenuItem>
        <yc-button
          [link]="true"
          class="main-nav-item" 
          [fontAwesomeIcon]="'envelope'"
          [langKey]="'PROGRAM:textInvitations'"
          [defaultText]="'Invitations'"
          [linkPath]="['/apply/invitations']"
          (onClick)="mobileMenuOpen = false;">
        </yc-button>
      </li>
      <li *ngIf="showAwardsLink"
        cdkMenuItem>
        <yc-button 
          class="main-nav-item" 
          [icon]="true"
          [fontAwesomeIcon]="'gift'"
          [langKey]="'common:hdrAwards'"
          [defaultText]="'Awards'"
          [linkPath]="['/apply/awards']"
          (onClick)="mobileMenuOpen = false;">
        </yc-button>
      </li>
    </ul>
  </nav>
</ng-template>

<ng-template #helpCircle>
  <yc-button *ngIf="!isBBGMApplicant"
    [isDropdownButton]="true"
    [icon]="true"
    [size]="'xl'"
    [fontAwesomeIcon]="'question-circle'"
    [dropdownActions]="supportLinks$ | async"
    [tooltipText]="'common:textHelp' | ycI18n: 'Help'"
    [placement]="'bottom'">
  </yc-button>
</ng-template>

<!-- Account Dropdown Template -->
<ng-template #accountDropdown>
  <yc-account-dropdown
    class="me-4"
    [accountName]="applicant.firstName + ' ' + applicant.lastName"
    [links]="links">
  </yc-account-dropdown>
</ng-template>

<!-- End Templates -->
